export default {"src":"/_next/static/media/ic_stars.ba27e0fa.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};